import { atom } from "jotai";

export const isAssistantRunnerOpenAtom = atom(false);

export const flushAgentSaveSignalAtom = atom<number>(0);

// Set when Genie or a capability dialog changed an agent. That agent's open
// editor refreshes, keeping what the user has not saved yet, or remounts when
// the change can reshape its form (a capability version).
export const agentFormRefreshAtom = atom<{
  agentId: string;
  remount: boolean;
} | null>(null);

export enum AssistantEditorSaveState {
  IDLE = "idle",
  PENDING_SAVE = "pending_save",
  SAVING = "saving",
  SAVED = "saved",
  ERROR = "error",
  FETCHING = "fetching",
}

export const assistantEditorSaveStateAtom = atom<AssistantEditorSaveState>(
  AssistantEditorSaveState.IDLE
);

export type PendingNavigationResolution = "wait" | "navigate" | "cancel";

export const isAssistantSaveInFlight = (
  saveState: AssistantEditorSaveState
): boolean =>
  saveState === AssistantEditorSaveState.PENDING_SAVE ||
  saveState === AssistantEditorSaveState.SAVING;

export const resolveAssistantPendingNavigation = (
  saveState: AssistantEditorSaveState
): PendingNavigationResolution => {
  if (isAssistantSaveInFlight(saveState)) {
    return "wait";
  }

  if (saveState === AssistantEditorSaveState.ERROR) {
    return "cancel";
  }

  return "navigate";
};
